import { ReactNode } from "react";

interface SocialTopicPanelHeaderProps {
  title: string;
  /** A small icon before the title. */
  icon?: ReactNode;
  /** A muted note or legend at the end of the header. */
  trailing?: ReactNode;
  testId?: string;
}

/**
 * Space under the last row of an overview card (timeline, share of voice,
 * channels, top voices), so the four cards end alike.
 */
export const SOCIAL_PANEL_BOTTOM_PADDING = "pb-5";

/** The title row of a topic page section (share of voice, channels, top voices, highlights). */
export function SocialTopicPanelHeader(props: SocialTopicPanelHeaderProps) {
  const { title, icon, trailing, testId } = props;

  return (
    <div className="flex min-h-9 items-center justify-between gap-3 px-5 pt-4" data-testid={testId}>
      <div className="flex min-w-0 items-center gap-2">
        {icon}
        {/* Small card titles read in the body font: the display font is for section headings. */}
        <h2 className="font-sans text-sm font-medium text-foreground">{title}</h2>
      </div>
      {trailing ? <div className="text-xs text-muted-foreground">{trailing}</div> : null}
    </div>
  );
}
